/* Krudo cart-drawer cleanup.
   PickEasy injects its #order-slots widget into every cart <form> it finds.
   Our drawer has two forms (CartDrawer-Form for line items, CartDrawer-FormSummary
   for subtotal/checkout), so the picker appears twice with duplicate ids.
   We keep the one in CartDrawer-Form (right after the line items) and remove
   the duplicate from CartDrawer-FormSummary on every injection. */
(function () {
  if (window.KrudoPickEasyCleanup) return;
  window.KrudoPickEasyCleanup = true;

  const TARGET_IDS = ['order-slots', 'order-slots-option', 'order-slots-cart-attributes'];
  const TARGET_SELECTOR = TARGET_IDS.map((id) => '#' + id).join(', ');

  function cleanup() {
    const form = document.getElementById('CartDrawer-FormSummary');
    if (!form) return;
    form.querySelectorAll(TARGET_SELECTOR).forEach((node) => node.remove());
  }

  function isRelevantNode(node) {
    if (node.nodeType !== 1) return false;
    if (TARGET_IDS.includes(node.id)) return true;
    return typeof node.querySelector === 'function' && node.querySelector(TARGET_SELECTOR) !== null;
  }

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (isRelevantNode(node)) {
          cleanup();
          return;
        }
      }
    }
  });

  function start() {
    cleanup();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
